import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { BannerLayout, BannerMessage } from '@wix/da-ds/pkg/Banner/lego';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './StashBanner.scss';

interface Props {
  className?: string;
}

const StashBanner: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <BannerLayout
      size="big"
      className={c(s['root'], className)}
      body={[
        <HiddenIcon key="icon" role="presentation" size={IconSize.MEDIUM} disableDefaultColors />,
        <BannerMessage key="message" weight="reg">
          {t('stashBanner.message', {
            postProcess: ['reactPostprocessor', 'featureBrancher'],
            prefix: <span className={s['prefix-message']}>{t('stashBanner.message.prefix')}</span>,
          })}
        </BannerMessage>,
      ]}
    />
  );
};

StashBanner.displayName = 'StashBanner';

export default StashBanner;
